module.exports = (__webpack_public_path__ || '') + "static/images/photo-1-c6449c56dc64f29971aef5adf2a7c7dc.jpg";